import { useState, useEffect } from 'react';
import '../css/secondaryBar.css';
import '../css/markdown.css';
import { useLanguage } from '../providers/preferenceProvider';
import '../css/secondaryBar.css';
import '../css/admin.css';
import Companies from '../shared/admin/companies';
import Users from '../shared/admin/users';
import Roles from '../shared/admin/roles';
import Rooms from '../shared/admin/rooms';
import Bookings from '../shared/admin/bookings';
import InformationPages from '../shared/admin/info';
import Statistics from '../shared/admin/statistics';
import SystemAccounts from '../shared/admin/systemAccounts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useSearchParams } from 'react-router-dom';

const Admin = () => {
  const { t } = useLanguage();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('companies');
  const tabs = ['companies', 'users', 'roles', 'rooms', 'bookings', 'info', 'systemAccounts', 'statistics'];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [navExpanded, setNavExpanded] = useState(false);

  useEffect(() => {
    setActiveTab(searchParams.get('tabIndex') || 'companies');
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [searchParams]);

  const handleNavClick = () => {
    if (isMobile) setNavExpanded((prev) => !prev);
  };

  const handleTabClick = (tab) => {
    searchParams.set('tabIndex', tab);
    setSearchParams(searchParams);
    if (isMobile) setNavExpanded(false);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
    case 'companies': return <Companies />;
    case 'users': return <Users />;
    case 'roles': return <Roles />;
    case 'rooms': return <Rooms />;
    case 'bookings': return <Bookings />;
    case 'info': return <InformationPages />;
    case 'systemAccounts': return <SystemAccounts />;
    case 'statistics': return <Statistics />;
    default: return <Companies />;
    }
  };

  return (
    <>
      <main className="main-container">
        <div className="main-box">
          <div className="main-header">{t.admin}</div>
          <div className="sidebar-wrapper">
            <div
              className={`secondary-nav${isMobile && navExpanded ? ' expanded' : ''}`}
              onClick={handleNavClick}
            >
              {(!isMobile || navExpanded) &&
                tabs.map((tab) => (
                  <div
                    key={tab}
                    className={`secondary-nav-item ${activeTab === tab ? 'active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); handleTabClick(tab); }}
                  >
                    {t.admin_tabs[tab]}
                    <span className="secondary-nav-arrow"><FontAwesomeIcon icon={faChevronDown} /></span>
                  </div>
                ))}
              {isMobile && !navExpanded && (
                <div className="secondary-nav-item active">
                  {t.admin_tabs[activeTab]}
                  <span className="secondary-nav-arrow"><FontAwesomeIcon icon={faChevronDown} /></span>
                </div>
              )}
            </div>
            <div className="info-tab-container">
              <div className="content-item">
                <div className="secondary-nav-header">{t.admin_tabs[activeTab]}</div>
                <div className="admin-content-loader">
                  {renderActiveTab()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Admin;